import React from 'react';
import Layout from '../../components/layout';
import SectionHeroImage from '../../components/shared/SectionHeroImage';
import FeatureDescription from '../../components/shared/FeatureDescription';
import { useStaticQuery, graphql } from 'gatsby';
import ImageGallery from 'react-image-gallery';
import { useImages } from '../../hooks';
import SEO from '../../components/seo';

const ConferencesPage = ({ pageContext: { locale } }) => {
	const imageQuery = useStaticQuery(
		graphql`
			query {
				gallery: allFile(
					filter: {
						extension: { regex: "/(jpg)|(jpeg)|(png)/" }
						sourceInstanceName: { eq: "GalleryImages" }
						relativeDirectory: { eq: "yritused/seminarid" }
					}
				) {
					edges {
						node {
							childImageSharp {
								fluid(maxWidth: 1000, quality: 75) {
									originalName
									...GatsbyImageSharpFluid
								}
							}
						}
					}
				}
				hero: file(
					extension: { regex: "/(jpg)|(jpeg)|(png)/" }
					sourceInstanceName: { eq: "GalleryImages" }
					relativeDirectory: { eq: "yritused/seminarid" }
					name: { in: "hero" }
				) {
					childImageSharp {
						fluid(quality: 75) {
							originalName
							...GatsbyImageSharpFluid
						}
					}
				}
			}
		`
	);

	const [images, heroImage] = useImages(imageQuery);

	return (
		<Layout locale={locale}>
			<SEO title='seminarid' />
			<div className='conferences'>
				{heroImage && (
					<SectionHeroImage
						image={heroImage}
						sizeClass='is-large'
						titleTranslationKey='yritused.seminarid.pealkiri'
					/>
				)}
				<section className='container'>
					<div className='tile is-ancestor'>
						<div className='tile is-vertical is-12'>
							<div className='tile'>
								<div className='tile is-6 is-parent is-vertical'>
									<FeatureDescription translationKey='yritused.seminarid.blokk1' />
									{/*<FeatureDescription translationKey='yritused.seminarid.blokk2' /> */}
								</div>
								<div className='tile is-6 is-parent'>
									<article className='tile is-child'>
										{images.length > 0 && (
											<ImageGallery items={images} showPlayButton={false} />
										)}
									</article>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</Layout>
	);
};

export default ConferencesPage;
